import sieviApi from "@/api/sieviApi"
// export const myAction = async ( { commit } ) => {

// }

export const obtainEvidencesDocente = async ( { commit }, { idHfs, idPeriodo, idContrato } ) => {

    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/evidencias/${idHfs}/${idPeriodo}/${idContrato}`)
        if (data.ok) {
            commit('setEvidences', data.evidencias)
            return { ok: true, message: data.message }
        } else {
            commit('setEvidences', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createEvidence = async ( { commit }, { idHfs, idContrato, file, description } ) => {
    try {
        const formData = new FormData();
        formData.append("contrato_id", idContrato)
        formData.append("hfsUser_id", idHfs)
        formData.append("file", file)
        formData.append("descripcion", description)

        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/evidencias`, formData)
        if (data.ok) {
            commit('updateEvidences', { evidences: data.evidencia, file })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const removeFileOnUpload = async( { commit }, { idHfsUser: idWeek, file } ) => {
    commit('removeFileOnUpload', { file, idWeek })
}

export const removeFileUpload = async( { commit }, { idFile, idHfsUser } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.delete(`/api/evidencias/${idFile}`)
        if (data.ok) {
            commit('deleteFileUpload', { idFile, idHfsUser })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const saveHfsUser = async( { commit }, { description, idHfsUser }) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/hfsuser`, { descripcion: description, idHfsUser})
        if (data.ok) {
            const { hfsUser } = data
            commit('saveHfsUser', { description, idHfsUser, hfsUser })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const cancelHfsUser = async( { commit }, { idHfsUser }) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/hfsuser/cancelar`, { idHfsUser})
        if (data.ok) {
            const { hfsUser } = data
            commit('cancelHfsUser', { idHfsUser, hfsUser })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainEvidencesResponsable = async ( { commit }, { id, campusId, hfsId, programId, teacherId, contractId, periodId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/evidencias/${id}/${campusId}/${hfsId}/${programId}/${teacherId}/${contractId}/${periodId}`)
        if (data.ok) {
            commit('setEvidences', data.evidencias)
            return { ok: true, message: data.message }
        } else {
            commit('setEvidences', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const approveWeek = async( { commit }, { idHfsUser }) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/semana/aprobar`, { idHfsUser })
        if (data.ok) {
            const { hfsUser } = data
            commit('approveWeek', { idHfsUser, hfsUser })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const disapproveWeek = async( { commit }, { idHfsUser, observation }) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/semana/desaprobar`, { idHfsUser, observacion: observation })
        if (data.ok) {
            const { hfsUser } = data
            commit('disapproveWeek', { idHfsUser, hfsUser })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainEvidencesAuditor = async ( { commit }, { campusId, programId, teacherId, contractId, periodId, hfsId } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/evidencias/${campusId}/${programId}/${teacherId}/${contractId}/${periodId}/${hfsId}`)
        if (data.ok) {
            commit('setEvidences', data.evidencias)
            return { ok: true, message: data.message }
        } else {
            commit('setEvidences', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}